<template>
  <div class="card-position">
    <div class="mb-10">
      <v-card
        ref="scroll-card"
        id="scroll-card"
        style="overflow-y: scroll"
        class="d-block"
        height="300"
        elevation="0"
        v-on:scroll.native="handleScroll"
      >
        <v-card-text v-if="feedbacks.length">
          <v-row v-for="feedback in feedbacks" :key="feedback.id" no-gutters>
            <v-col
              :class="
                feedback.sent_by == 'ROLE_HOST'
                  ? 'd-flex justify-start'
                  : 'd-flex justify-end'
              "
            >
              <div class="d-block" style="max-width: 80%">
                <v-card
                  elevation="0"
                  class="px-5 py-2 my-2"
                  rounded="lg"
                  :color="
                    feedback.sent_by == 'ROLE_HOST'
                      ? 'blue lighten-3 rounded-tl-0'
                      : 'grey lighten-3 rounded-tr-0'
                  "
                >
                  <span
                    v-if="feedback.sent_by == 'ROLE_HOST'"
                    class="d-block font-weight-bold"
                  >
                    {{ hostName }}
                  </span>
                  <span>
                    {{ feedback.message }}
                  </span>
                </v-card>
                <span
                  class="text-caption"
                  :class="
                    feedback.sent_by == 'ROLE_HOST'
                      ? 'd-flex justify-start'
                      : 'd-flex justify-end'
                  "
                >
                  {{ formatDate(feedback.date_created) }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-else class="d-flex justify-center align-center empty-card-text-height">
          <EmptyState />
        </v-card-text>
      </v-card>

      <v-btn
        @click="scrollFeedbacksToBottom"
        class="new-feedbacks-button"
        color="primary"
        fab
        small
        rounded
        v-if="showMessage"
      >
        <v-icon> mdi-chevron-double-down </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { catalogDate } from '@/util/catalog'
import EmptyState from '@/components/app/EmptyState'

export default {
  name: 'HostOnboardingFeedbacks',
  props: {
    feedbacks: {
      type: Array,
      required: true,
      default: [],
    },
    hostName: {
      type: String,
      required: true,
      default: 'Host',
    },
  },
  components: {
    EmptyState
  },
  data() {
    return {
      formatDate: catalogDate,
      scrollPosition: 0,
      showMessage: true,
    }
  },
  mounted() {
    this.showMessage = !(
      document.querySelector('#scroll-card').scrollHeight == 300
    )
  },
  methods: {
    scrollFeedbacksToBottom() {
      this.$refs['scroll-card'].$el.scrollTop = 1000000
    },

    scrollAtBottom() {
      if (this.$refs['scroll-card']) {
        const scrollCardEl = this.$refs['scroll-card'].$el
        this.showMessage =
          this.scrollPosition + scrollCardEl.clientHeight <=
          scrollCardEl.scrollHeight - scrollCardEl.scrollHeight * 0.2
      }
    },

    handleScroll() {
      const scrollCard = this.$refs['scroll-card'].$el
      this.scrollPosition = scrollCard.scrollTop
      this.scrollAtBottom()
    },
  },
}
</script>

<style scoped>
.new-feedbacks-button {
  position: absolute;
  bottom: 5%;
  left: 82%;
}

.card-position {
  position: relative;
}

.empty-card-text-height {
  height: 300px;
}
</style>